import { actions as formActions } from 'react-redux-form';

import { getTokens as getTokensAction } from '../actions/tokens';
import { entity as emailSnippets } from '../ducks/emailSnippets';
import EmailWorkflowDuck from './EmailWorkflowDuck';
import previewEmail from '../actions/previewEmail';
import createEmail from '../actions/createEmail';


export default class UserEmailWorkflowDuck extends EmailWorkflowDuck {
  constructor() {
    super();

    this.name = 'userEmailWorkflow';

    this.defaultModelState = {
      email: {snippet: {subject: '', reply_to: '', body: ''}, recipients: []}
    };

    this.getTokens = this.getTokens.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.setPreviewRecipientId = this.setPreviewRecipientId.bind(this);
    this.setRecipients = this.setRecipients.bind(this);
    this.validateSnippet = this.validateSnippet.bind(this);
  }

  getTokens() {
    return (dispatch) => {
      return dispatch(getTokensAction('userEmail')).then((response) => {
        dispatch(formActions.change(`${this.name}.model.email.snippet.tokens`, response.tokens));
      });
    }
  };

  sendEmail(recipients, snippet) {
    return (dispatch) => {
      //noinspection JSUnusedLocalSymbols
      const {tokens, ...dupSnippet} = snippet;

      dispatch(formActions.setPending(`${this.name}.model.email`));

      return dispatch(createEmail({recipients: recipients, snippet: dupSnippet, user_mailer: true}));
    }
  };

  setPreviewRecipientId(previewUser, snippet) {
    return (dispatch) => {
      dispatch({type: this.types().SET_PREVIEW_CONTENT, previewContent: null});

      dispatch(previewEmail({
        recipients: [previewUser],
        snippet,
        user_mailer: true
      }))
        .then((response) => dispatch(this.setPreviewContent(response.snippet_preview[0])));

      return dispatch({type: this.types().SET_ACTIVE_PREVIEW, previewRecipientId: previewUser.id});
    }
  };

  setRecipients(recipientIds) {
    return (dispatch) => dispatch(
      formActions.change(`${this.name}.model.email.recipients`, recipientIds)
    )
  };

  validateSnippet(snippet) {
    return (dispatch) => {
      //noinspection JSUnusedLocalSymbols
      const {tokens, ...dupValues} = snippet;

      dupValues.validate = true;

      return dispatch(formActions.submitFields(`${this.name}.model.email.snippet`,
        dispatch(emailSnippets.actions.validate(dupValues))
        // We catch and re-reject to deference the errors. Ugly.
          .catch((response) => {
            return Promise.reject(response.errors);
          })
      ));
    }
  };
}
